// THIS CODE WAS AUTO-GENERATED from '/packages/icon/icons/makeSvgsIntoJsx.js'
// PLEASE DO NOT EDIT HERE. EDIT THE FILE THAT MADE THIS
import React from 'react'
import { sanitizeProps } from '@fs/zion-frontend-friends'
import BaseIcon, { type IconProps } from './BaseIcon'
import { avatarBgCss, avatarHairCss, avatarFaceCss, avatarShadowCss, avatarShirtCss } from './avatarStyles'

export default (props: IconProps): JSX.Element => (
  <BaseIcon {...sanitizeProps(props)}>
    <path fill="#a6eefa" d="M0 0h24v24H0z" className={avatarBgCss} />
    <path
      fill="#003057"
      d="M7.73 11.07 7 9.18c-.11-.26.07-1.18 0-1.33s-.2-2.85.73-3.7a7 7 0 0 1 1.49-1s0-.34.9-.34.12-.55 1.53-.33a16 16 0 0 0 1.68.23h.31s1.13.44 1.06.92 1.13 0 1.13 0v.27s1 0 1 2.59-.19 3.33-.47 3.47a2 2 0 0 0-.59.67s-2.77 1.94-8.04.44"
      className={avatarHairCss}
    />
    <path
      fill="#0181a1"
      d="M15.56 17.59c-.35-.26-.38-2.91-.38-2.91a1.4 1.4 0 0 0 .34-.72 2.3 2.3 0 0 1 .36-1.26.6.6 0 0 0 .39-.18c.15-.19.19-1.37.31-1.71s.19-.89-.2-.85-.58.67-.58.67a5 5 0 0 0-.16-1.7c-.23-.67.2-2.15-.74-2.71A3.6 3.6 0 0 0 12.19 6a5 5 0 0 1-2.53-.19c-.75-.26-1.37 1-1.49 1.52a25 25 0 0 0-.47 3.25V11s-.27-1.19-.51-1.26-.66-.07-.58.81.17.2.51 1.86c.18 1 .53.22.53.22a4.3 4.3 0 0 0 1 2.54v1.38a1.8 1.8 0 0 1-1.3 1.78c4.33 4.62 9.91.15 9.91.15s-1.49-.74-1.7-.89"
      className={avatarFaceCss}
    />
    <path
      fill="#007694"
      d="M15.18 14.68a11 11 0 0 1-1.85 1.72 3.4 3.4 0 0 1-3.64-.22 4 4 0 0 1-1.06-.94V16c2.12 2.91 5.4 1.63 7 1.6-.43-.27-.45-2.92-.45-2.92"
      className={avatarShadowCss}
    />
    <path
      fill="#01496e"
      d="M21.34 24a6 6 0 0 0 .66-2.75c0-2.13-6.07-3.5-6.07-3.5l-.14.23s-.71 1.57-4 1.57a4.6 4.6 0 0 1-3.57-1.73C7.44 18 2 19 2 21.27A6 6 0 0 0 2.64 24Z"
      className={avatarShirtCss}
    />
  </BaseIcon>
)
